import { toast, ToastOptions } from 'react-toastify'

export default (type: string, message: string) => {
  const config: ToastOptions = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }

  switch (type) {
    case 'info':
      toast.info(message, config)
      break

    case 'success':
      toast.success(message, config)
      break

    case 'warning':
      toast.warning(message, config)
      break

    case 'error':
      toast.error(message, config)
      break

    default:
      toast(message, config)
      break
  }
}
